
import {defineComponent} from 'vue'

export default defineComponent({
    name: "ButtonOpenFilter",
    props: {
        text: {
            type: String,
            required: true
        }
    }
});
